import OapMikMak from './code/Scripts/components/OapMikMak.vue';
import OapMikMakCoupon from './code/Scripts/components/OapMikMakCoupon.vue';

export default {
  components: {
    OapMikMak,
    OapMikMakCoupon,
  },
};
